import React from 'react';
import beginBright from '../assets/BB Main Logo.png';
import { Image } from 'react-bootstrap';
import {
  PRODUCT_NAME
} from '../constants/constants';

function Logo({ onClick }) {
  return (
    <Image
      fluid
      src={beginBright}
      alt={PRODUCT_NAME}
      onClick={onClick}
      style={{ padding: 10 }}
      data-testid="logo"
    />
  );
}

export default Logo;
